import React from 'react';

interface DeleteWarningPopupProps {
  itemName: string;
  fieldCount: number;
  onCancel: () => void;
  onDelete: () => void;
}

interface ConditionalPopupProps {
  fields: any[];
  selectedItemId: string;
  fieldId: string;
  isConditional: boolean;
  selectedField: any;
  onCancel: () => void;
  onSave: (fieldId: string, conditionalField: string | null, conditionalValue: string | null) => void;
}

export const DeleteWarningPopup: React.FC<DeleteWarningPopupProps> = ({
  itemName,
  fieldCount,
  onCancel,
  onDelete
}) => {
  return (
    <div className="warning-popup-overlay">
      <div className="warning-popup">
        <h3 className="warning-popup-title">Warning</h3>
        <p className="warning-popup-message">
          Are you sure you want to delete "{itemName}"? 
          This item contains {fieldCount} form {fieldCount === 1 ? 'field' : 'fields'} that will also be deleted.
        </p>
        <div className="warning-popup-buttons">
          <button 
            className="warning-popup-button cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="warning-popup-button delete"
            onClick={onDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export const ConditionalPopup: React.FC<ConditionalPopupProps> = ({
  fields,
  selectedItemId,
  fieldId,
  isConditional,
  selectedField,
  onCancel,
  onSave
}) => {
  const [selectedConditionalField, setSelectedConditionalField] = React.useState<string>(selectedField?.conditionalField || '');
  const [selectedConditionalValue, setSelectedConditionalValue] = React.useState<string>(selectedField?.conditionalValue || '');

  return (
    <div className="warning-popup-overlay">
      <div className="conditional-popup">
        <h3 className="conditional-popup-title">Make Conditional</h3>
        <div className="conditional-popup-dropdowns">
          <div className="conditional-popup-dropdown">
            <select
              value={selectedConditionalField}
              onChange={(e) => {
                setSelectedConditionalField(e.target.value);
                setSelectedConditionalValue(''); // Reset value when field changes
              }}
            >
              <option value="">Select field...</option>
              {fields.filter(f => 
                f.type === 'options' && f.id !== fieldId
              ).map(field => (
                <option key={field.id} value={field.id}>
                  {field.value || 'Untitled Question'}
                </option>
              ))}
            </select>
          </div>
          <div className="conditional-popup-dropdown">
            <select
              value={selectedConditionalValue}
              onChange={(e) => setSelectedConditionalValue(e.target.value)}
            >
              <option value="">Select option...</option>
              {fields.find(f => f.id === selectedConditionalField)?.options?.map((option: string) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="conditional-popup-buttons">
          <button 
            className="conditional-popup-button cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className={`conditional-popup-button ${isConditional ? 'remove' : 'confirm'}`}
            onClick={() => {
              if (isConditional) {
                onSave(fieldId, null, null);
              } else if (selectedConditionalField && selectedConditionalValue) {
                onSave(fieldId, selectedConditionalField, selectedConditionalValue);
              }
            }}
          >
            {isConditional ? 'Remove Conditional' : 'Make Conditional'}
          </button>
        </div>
      </div>
    </div>
  );
}; 